import { useState, useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import CartaExpressWidget from '../components/widgets/CartaExpressWidget';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function CartaWidgetPublicPage() {
  const { restaurantId } = useParams();
  const [searchParams] = useSearchParams();
  const [menus, setMenus] = useState([]);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  const config = useMemo(() => {
    const colorParam = searchParams.get('color');
    const radiusParam = searchParams.get('radius');
    const themeParam = searchParams.get('theme') || 'light';
    const langParam = searchParams.get('lang') || 'es';
    const payParam = searchParams.get('pay');
    return {
      theme: themeParam,
      primaryColor: '#' + (colorParam || 'F97316'),
      restaurantName: restaurant?.name || 'Carta Digital',
      restaurantLogo: restaurant?.logo_url || null,
      borderRadius: (radiusParam || '12') + 'px',
      language: langParam,
      paymentMethods: payParam ? payParam.split(',').filter(Boolean) : ['restaurant'],
    };
  }, [searchParams, restaurant]);

  const isDark = config.theme === 'dark';
  const bg = isDark ? '#0f172a' : '#f3f4f6';
  const mutedText = isDark ? '#94a3b8' : '#64748b';

  useEffect(() => {
    const load = async () => {
      try {
        const [menuRes, restRes] = await Promise.all([
          fetch(`${API_URL}/api/widget/public/restaurants/${restaurantId}/menus`),
          fetch(`${API_URL}/api/widget/public/restaurants/${restaurantId}/info`),
        ]);
        if (menuRes.ok) {
          const data = await menuRes.json();
          setMenus(Array.isArray(data) ? data : []);
        }
        if (restRes.ok) setRestaurant(await restRes.json());
      } catch {}
      finally { setLoading(false); }
    };
    load();
  }, [restaurantId]);

  const handleConfirm = async (data) => {
    try {
      const payload = {
        restaurant_id: restaurantId,
        guest_name: data.guestName,
        guest_email: data.guestEmail,
        guest_whatsapp: data.guestWhatsapp,
        party_size: data.partySize,
        date: data.selectedDate ? new Date(data.selectedDate).toISOString().slice(0, 10) : null,
        time: data.selectedTime,
        occasion: data.occasion,
        custom_occasion: data.customOccasion,
        allergies: data.allergies,
        special_requests: data.requests,
        requirements: data.requirements,
        custom_requirement: data.customReq,
        payment_method: data.paymentMethod,
        order: data.order,
        total: data.totalPrice,
        source: 'carta_widget',
      };
      const res = await fetch(`${API_URL}/api/widget/public/restaurants/${restaurantId}/reservations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        let msg = 'No pudimos enviar la reservación';
        try { const j = await res.json(); if (j?.detail) msg = j.detail; } catch {}
        throw new Error(msg);
      }
      toast.success('¡Reserva enviada!');
    } catch (err) {
      toast.error(err?.message || 'No pudimos enviar la reservación');
      throw err;
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: mutedText }}>
          <div style={{ width: 48, height: 48, border: `4px solid ${config.primaryColor}`, borderTop: '4px solid transparent', borderRadius: '50%', margin: '0 auto 16px', animation: 'spin 1s linear infinite' }} />
          <p style={{ fontSize: 14 }}>Cargando carta...</p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: bg, padding: '24px 12px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <CartaExpressWidget config={config} menus={menus} onConfirm={handleConfirm} />
    </div>
  );
}
